export default __webpack_public_path__ + "static/media/arrow-next-white.1e4113f9.svg";